import React, { ReactNode, Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import { Key } from "antd/lib/table/interface";
import Button from "@Components/Button";
import "./ActionBarComponent.scss";
import { Close } from "assets/icons";

export interface ActionBarComponentProps {
  children?: ReactNode;
  /** SelectedRowKeys of table */
  selectedRowKeys?: Key[];
  /** SetSelectedRowKeys of table*/
  setSelectedRowKeys?: Dispatch<SetStateAction<Key[]>>;
  /**Handle cancel selection */
  handleCancelAction?: () => void;
  /**Row selection */
  rowSelections?: any;
  translateSelected?: string;
  translateLine?: string;
}

function ActionBarComponent(props: ActionBarComponentProps) {
  const {
    children,
    selectedRowKeys = [],
    handleCancelAction,
    setSelectedRowKeys,
    translateSelected = "Đã chọn",
    translateLine = "dòng",
  } = props;

  const handleCancel = React.useCallback(() => {
    if (typeof handleCancelAction !== "undefined") {
      handleCancelAction();
    } else {
      setSelectedRowKeys([]);
    }
  }, [setSelectedRowKeys, handleCancelAction]);

  return (
    <div
      className={classNames(
        "action-bar-container",
        selectedRowKeys?.length > 0
          ? "action-bar-active"
          : "action-bar-inactive"
      )}
    >
      <div className="title-and-action">
        <div className="item-selected-counter">
          {translateSelected} {selectedRowKeys?.length} {translateLine}
        </div>
        <div className="line-verticle"></div>
        {children}
      </div>

      {selectedRowKeys?.length > 0 && (
        <div className="action-button">
          <Close fillColor="white" onClick={handleCancel} />
        </div>
      )}
    </div>
  );
}
export default ActionBarComponent;
